var samsung_AA59_00382A = {
    name: "AA59_00382A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_CYCLEWINDOWS",
            name: "KEY_CYCLEWINDOWS",
            icon: "KEY_CYCLEWINDOWS",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,238,235,90,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_102ND",
            name: "KEY_102ND",
            icon: "KEY_102ND",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,175,125,90,136],
        },
        {
            function: "pre-ch",
            name: "pre-ch",
            icon: "pre-ch",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,174,253,106,136],
        },
        {
            // function: "KEY_TV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,173,126,234,136],
        },
        {
            function: "ch-mgr",
            name: "ch-mgr",
            icon: "ch-mgr",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,173,175,110,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,175,250,170,136],
        },
        {
            function: "srs",
            name: "srs",
            icon: "srs",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,213,173,238,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,170,255,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,251,213,106,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,181,189,218,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,222,182,174,136],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,246,181,110,136],
        },
        {
            function: "pip",
            name: "pip",
            icon: "pip",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,253,213,90,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,170,191,234,136],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,235,117,218,136],
        },
        {
            function: "p-mode",
            name: "p-mode",
            icon: "p-mode",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,235,90,238,136],
        },
        {
            function: "s-mode",
            name: "s-mode",
            icon: "s-mode",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,237,235,106,136],
        },
        {
            function: "still",
            name: "still",
            icon: "still",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,182,251,106,136],
        },
        {
            function: "p-size",
            name: "p-size",
            icon: "p-size",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,214,247,106,136],
        },
        {
            function: "swap",
            name: "swap",
            icon: "swap",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,190,245,90,136],
        },
        {
            function: "size",
            name: "size",
            icon: "size",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,170,223,218,136],
        },
        {
            function: "p-up",
            name: "p-up",
            icon: "p-up",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,221,118,186,136],
        },
        {
            function: "dual",
            name: "dual",
            icon: "dual",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,255,170,170,136],
        },
        {
            function: "turbo",
            name: "turbo",
            icon: "turbo",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,238,181,174,136],
        },
        {
            function: "position",
            name: "position",
            icon: "position",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,222,237,90,136],
        },
        {
            function: "p-down",
            name: "p-down",
            icon: "p-down",
            command: [68,0,4,61,2,22,2,61,2,127,6,66,18,95,18,44,2,66,191,42,253,95,174,190,186,136],
        },
    ]
}
export default samsung_AA59_00382A